import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function NotificationOnIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M22.457 17.335L21.7695 17.1089C20.4844 16.6855 19.6201 15.5063 19.6201 14.1426L19.4883 9.92871C19.4053 7.9126 18.3525 6.04053 16.6738 4.92139L11.9775 1.79004L7.2998 4.90772C5.60644 6.03663 4.55371 7.92627 4.48535 9.97071L4.37988 14.1738C4.37988 15.5063 3.51562 16.6855 2.23047 17.1089L1.54297 17.335V19.9917H9.64745C9.66277 21.2688 10.696 22.2957 11.9767 22.2957C13.2575 22.2957 14.2908 21.2688 14.3061 19.9917H22.457V17.335Z",
    fill: "currentColor"
  }));
}